import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={100}
    height={100}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.1} cx={50} cy={50} r={50} fill="#C4C4C4" />
    <path
      d="M45.813 61.258v3.78c1.218.255 2.052.766 2.052 1.346 0 .834-1.732 1.475-3.783 1.475-2.116 0-3.783-.641-3.783-1.475 0-.577.834-1.09 2.052-1.347v-5.19c-.32-.128-.641-.32-1.026-.45C29.91 53.757 26 61.643 26 64.978c0 6.54 13.658 10.452 26.29 10.452s25.584-3.783 25.584-7.056c.064-3.077-16.479-1.218-32.06-7.117l-.001.002Zm28.31-33.863s-9.778-.087-13.88 1.452c-2.053.767-5.836 3.528-9.106 5.002a15.959 15.959 0 0 1-6.352 1.349v30.87a.705.705 0 1 1-1.41 0v-45.72a1.194 1.194 0 0 1-.129-.45.92.92 0 0 1 .898-.898c.513 0 .767.383.767.898a.926.926 0 0 1-.128.45v.766c1.09.706 3.398 1.86 7.502 2.373 2.373.32 5.13-.064 7.567-.064 3.59-.064 14.264 3.972 14.264 3.972"
      fill="#63AD53"
    />
  </svg>
);

export default SvgComponent;
